import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { fetchOrganization } from '../../../actions/OrganizationActions';
import { fetchCallFlow } from '../../../actions/CallFlowActions';

import { CallFlowInfo } from '../../../components';
import { CrudTabs, LinkTo, Loading } from '../../../helpers';

class CallFlowShowPage extends Component {

  static propTypes = {
    item: PropTypes.shape({
      id: PropTypes.number
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        organizationId: PropTypes.string.isRequired,
        callFlowId: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    itemFetched: PropTypes.bool.isRequired,
    fetchOrganization: PropTypes.func.isRequired,
    fetchCallFlow: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { match: { params: { organizationId, callFlowId } } } = this.props;

    this.props.fetchOrganization(organizationId);
    this.props.fetchCallFlow(callFlowId);
  }

  render() {
    const { match: { params: { organizationId, callFlowId } }, item, itemFetched } = this.props;

    return (
      <div id="call-flow-show">
        <div className="row page-titles">
          <div className="col-12">
            <h3 className="text-themecolor">
              {isEmpty(item) ? 'Call Flow' : `Call Flow: ${item.id} | ${get(item, 'attributes.name')}`}
            </h3>
          </div>
        </div>

        <CrudTabs
          model={`organizations/${organizationId}/callFlows`}
          id={callFlowId}
          active="show"
          afterTabs={[(
            <LinkTo
              icon="list"
              className="nav-link"
              href={`organizations/${organizationId}/callFlows/${item.id}/entries`}
            >
              Call Flow Entries
            </LinkTo>
          )]}
        />

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-block">
                <Loading loaded={itemFetched}>
                  <CallFlowInfo item={item} />
                </Loading>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({
  callFlows: {
    item,
    itemFetched
  }
}) => ({ item, itemFetched }), { fetchOrganization, fetchCallFlow })(CallFlowShowPage);
